<template>
  <div class="selected-coin">
    <div class="show-selected-coin">
      <div class="coin">
        <img :src="require('../../../assets/gold/geram.png')" alt="">
        <div class="name">
          <span class="name-span">گرم طلا</span>
        </div>
      </div>

      <div class="line"></div>

      <div class="select-type">
        <button @click="selectUsdt = true ; selectToman = false"
                :class="{'gray-btn' : selectUsdt === true , 'solid-gray-btn' : selectUsdt === false }">USDT | تتر
        </button>
        <button @click="selectToman = true ; selectUsdt = false"
                :class="{'gray-btn' : selectToman === true , 'solid-gray-btn' : selectToman === false }">TMN |
          تومان
        </button>
      </div>

    </div>

    <div class="search-coin">
      <label>
        <img src="../../../assets/icon/search.png" alt="">
        <input v-model="regex" type="search" class="search-input" placeholder="جستجو">
      </label>
    </div>

    <div class="table-coin">
      <table>
        <tr class="stiky">
          <th class="right-text">رمز ارز</th>
          <th class="center-text">قیمت واحد</th>
          <th class="left-text">تغییرات</th>
        </tr>
        <tr  @click="selectMarketType(item.relatedCoin)" v-for="(item , index) in coins" :key="index">
          <td class="td-right">
            <div class="name-coin">
              <inline-svg :src="require('../../../assets/goldIcon/' + item.logo + '.svg')"/>
              <div class="name-sec">
                <span class="name">{{ item.name }}</span>
              </div>
            </div>
          </td>
          <td class="number td-center">{{ item.price.toLocaleString() }}</td>
          <td class="number td-left" :class="{'red' : item.lastChange < 0 ,'green' : item.lastChange > 0}">{{ item.lastChange }}</td>
        </tr>
      </table>
    </div>

  </div>
</template>

<script>
export default {
  name: "selected-coin",
  props:{
    coin:String
  },

  data() {
    return {
      selectUsdt: true,
      selectToman: false,
      regex:'',
      coins: [
        {name: 'گرم', price: 123456789, relatedCoin: 'geram', logo: 'geram', lastChange: '+3.2', value: 12352648},
        {name: 'مثقال', price: 123456789, relatedCoin: 'mesghal', logo: 'mesghal', lastChange: '-3.2', value: 12352648},
        // {name: 'سکه تمام', price: 123456789, relatedCoin: 'tamam', logo: 'sectamami', lastChange: '+3.2', value: 12352648},
        {name: 'نیم سکه', price: 123456789, relatedCoin: 'nim', logo: 'nim', lastChange: '-3.2', value: 12352648},
        {name: 'تمام سکه', price: 123456789, relatedCoin: 'tmamsec', logo: 'tamam', lastChange: '+3.2', value: 12352648},
      ]
    }
  },

  methods:{
    selectMarketType(e){
      this.state.marketType = e;
      this.$router.push(e)
    },
    filterCoins(){
      return this.coins.filter(coin => {
        if(coin.relatedCoin.toLowerCase().includes(this.regex.toLowerCase()) || coin.name.includes(this.regex) || this.$coin2Snake[coin.relatedCoin].toLowerCase().includes(this.regex.toLowerCase()) ){
          return coin
        }
      })
    }
  }

}
</script>

<style lang="scss" scoped>
.selected-coin {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 8px;

  .show-selected-coin {
    display: flex;
    flex-direction: row;
    color: #FBFBFD;
    justify-content: space-between;

    .coin {
      display: flex;
      flex-direction: row;
      gap: 8px;
      align-items: center;

      img {
        width: 32px;
        height: 32px;
      }

      .name {
        display: flex;
        flex-direction: column;
        text-align: right;

        .name-span {
          font-size: clamp(14px, 2vw, 16px);
          color: #FBFBFD;
        }

        .relation-name {
          font-size: clamp(8px, 2vw, 10px);
          color: rgba(215, 200, 200, 1);
        }
      }
    }

    .line {
      width: 2px;
      border-right: 1px solid #1199FA;
    }

    .select-type {
      gap: 10px;
      display: flex;
      flex-direction: row;

      button {
        width: 92px;
        height: 35px !important;
      }
    }
  }

  .search-coin {
    .search-input {
      width: 100%;
      background-color: rgba(0, 0, 0, 0.3);
      border-radius: 4px;
      color: #FBFBFD;
      height: 30px;
      padding-right: 30px;
    }

    label {
      position: relative;

      img {
        position: absolute;
        top: 25%;
        right: 5px;
      }
    }
  }

  .table-coin {

    height: 305px;
    overflow: auto;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    .stiky{
      position: sticky;
      top: 0;
      height: 30px;

      .center-text{
        padding-left: 5px;
      }
      .right-text{
        text-align: right;
        padding-right: 10px;
      }

      .left-text{
        text-align: left;
      }

      &:hover{
        background: transparent !important;
      }
    }

    .td-right{
      text-align: right;
    }

    .td-center{
      text-align: center;
    }

    .td-left{
      text-align: left;
    }

    table {
      table-layout: fixed;

      th {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }

      tr {
        height: 46px;
        &:hover {
          cursor: pointer;
          background: linear-gradient(259.33deg, rgba(28, 52, 102, 0) 7.64%, rgba(28, 52, 102, 0.35) 52.12%, rgba(20, 37, 69, 0.24) 83.62%);
        }
      }

      td {
        font-size: clamp(10px, 2vw, 12px);
        text-align: center;
      }
    }

    .name-coin {
      display: flex;
      flex-direction: row;
      gap: 5px;
      align-items: center;

      img {
        width: 25px;
        height: 25px;
      }

      .name-sec {
        display: flex;
        flex-direction: column;
        gap: 5px;
        text-align: right;
        align-items: start;

        span {
          font-size: 10px;
          display: ruby;
        }

        small {
          color: #8C8585;
          font-size: 10px;
        }
      }
    }
  }
}
</style>